module.exports = __webpack_public_path__ + "media/LoopSmall.75943951.mp4";